import { STEPS } from '@/components/ShowModal/config';

export default {
    /**
     * Opens modal.
     *
     * @param  {object} options  Vuex context
     */
    openModal({ commit }) {
        commit('setModalOpen', true);
    },

    /**
     * Closes modal.
     *
     * @param  {object} options  Vuex context
     */
    closeModal({ commit }) {
        commit('setModalOpen', false);
    },

    /**
     * Updates step to the next one.
     *
     * @param  {object} options  Vuex context
     */
    nextStep({ commit, getters }) {
        let nextStepIndex = getters.stepIndex + 1;

        if (getters.step(nextStepIndex) === STEPS.TRIAL && getters.skipTrial) {
            nextStepIndex += 1;
        }

        commit('setStep', getters.step(nextStepIndex));
    },

    /**
     * Updates step to the previous one.
     *
     * @param  {object} options  Vuex context
     */
    previousStep({ commit, getters }) {
        let previousStepIndex = getters.stepIndex - 1;

        if (getters.step(previousStepIndex) === STEPS.TRIAL && getters.skipTrial) {
            previousStepIndex -= 1;
        }

        commit('setStep', getters.step(previousStepIndex));
    },
};
